<template>
    <div class="inner">
        <p>
            (우 24264) 강원특별자치도 춘천시 삭주로 3, 시청 별관 3층
            <i>(문의 033-245-5264)</i> <br />웹진에 실린 글의 내용은
            &lt;춘천시도시재생지원센터&gt; 의 공식 의견과 다를 수 있으며, 글과
            사진 등의 콘텐츠는 허가없이 문단으로 사용할수 없습니다.
        </p>
    </div>
</template>

<script>
export default {
    name: "WebZineViewCopyRight",
};
</script>

<style scoped></style>
